import { create } from 'zustand';

export type HighlightOrigin = 'pin' | 'index' | 'navigator';

interface Intent {
  owner: string;
  slug: string;
  origin: HighlightOrigin;
  rev: number;
}

interface PinHighlight {
  slug: string | null;
  origin: HighlightOrigin | null;
  intents: Intent[];
  activate: (owner: string, slug: string, origin: HighlightOrigin) => void;
  release: (owner: string) => void;
  clearAll: () => void;
}

const RELEASE_MS = 120;
let revision = 0;

const topOf = (intents: Intent[]) => {
  const top = intents.at(-1);
  return { slug: top?.slug ?? null, origin: top?.origin ?? null };
};

export const usePinHighlight = create<PinHighlight>((set, get) => ({
  slug: null,
  origin: null,
  intents: [],
  activate: (owner, slug, origin) => {
    revision += 1;
    const intents = [...get().intents.filter((i) => i.owner !== owner), { owner, slug, origin, rev: revision }];
    set({ intents, ...topOf(intents) });
  },
  release: (owner) => {
    const held = get().intents.find((i) => i.owner === owner);
    if (!held) return;
    setTimeout(() => {
      const current = get().intents;
      const intents = current.filter((i) => i.rev !== held.rev);
      if (intents.length === current.length) return;
      set({ intents, ...topOf(intents) });
    }, RELEASE_MS);
  },
  clearAll: () => set({ intents: [], slug: null, origin: null }),
}));
